(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se-announcement"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('se-announcement'))customElements.define('se-announcement',class extends HTMLElement{
 connectedCallback(){
  this.viewport=this.querySelector('.se-announcement-viewport');this.track=this.querySelector('.se-announcement-track');this.group=this.querySelector('[data-original]');this.control=this.querySelector('button');
  this.items=[...this.group.children];this.paused=false;this.hover=false;this.focused=false;
  this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.abort=new AbortController();const options={signal:this.abort.signal};
  this.control.addEventListener('click',()=>{this.paused=!this.paused;this.control.setAttribute('aria-pressed',String(this.paused));this.control.setAttribute('aria-label',this.paused?this.control.dataset.playLabel:this.control.dataset.pauseLabel);this.control.textContent=this.paused?'▶':'Ⅱ';this.sync()},options);
  this.addEventListener('pointerenter',e=>{this.hover=e.pointerType==='mouse';this.sync()},options);
  this.addEventListener('pointerleave',()=>{this.hover=false;this.sync()},options);
  this.addEventListener('focusin',e=>{this.focused=e.target.matches('a');this.sync();if(this.focused)this.reveal(e.target.closest('[data-message]'))},options);
  this.addEventListener('focusout',e=>{this.focused=!!e.relatedTarget&&this.contains(e.relatedTarget)&&e.relatedTarget.matches('a');if(!this.focused&&!this.editorSelected)this.removeAttribute('data-editing');this.sync()},options);
  document.addEventListener('visibilitychange',()=>this.sync(),options);
  this.motion.addEventListener('change',()=>{this.rebuild();this.sync()},options);
  this.addEventListener('shopify:block:select',e=>{const item=this.items.find(item=>item===e.target||item.contains(e.target));if(item){this.editorSelected=true;this.reveal(item)}},options);
  this.addEventListener('shopify:block:deselect',()=>{this.editorSelected=false;this.removeAttribute('data-editing');this.sync()},options);
  this.observer=new ResizeObserver(()=>this.scheduleRebuild());this.observer.observe(this.viewport);this.items.forEach(item=>this.observer.observe(item,{box:'border-box'}));
  this.rebuild();this.sync();document.fonts.ready.then(()=>{if(this.isConnected)this.scheduleRebuild()});
 }
 copy(node){
  const clone=node.cloneNode(true);clone.setAttribute('aria-hidden','true');clone.setAttribute('data-repeat','');clone.removeAttribute('data-original');
  [clone,...clone.querySelectorAll('*')].forEach(el=>{el.removeAttribute('id');el.removeAttribute('data-shopify-editor-block');el.removeAttribute('data-shopify-editor-section');if(el.matches('a,button,input,select,textarea,[tabindex]'))el.setAttribute('tabindex','-1')});return clone
 }
 scheduleRebuild(){cancelAnimationFrame(this.rebuildFrame);this.rebuildFrame=requestAnimationFrame(()=>{if(this.isConnected)this.rebuild()})}
 rebuild(){
  const oldAnimation=this.track.getAnimations()[0];
  if(oldAnimation&&this.distance&&!this.hasAttribute('data-editing'))this.offset=(oldAnimation.effect.getComputedTiming().progress||0)*this.distance;
  this.querySelectorAll('[data-repeat]').forEach(el=>el.remove());
  if(!this.items.length){this.removeAttribute('data-ready');this.control.hidden=true;return}
  this.setAttribute('data-ready','');this.control.hidden=this.motion.matches;
  const baseWidth=this.group.getBoundingClientRect().width;
  if(!baseWidth)return;
  if(!this.motion.matches){
   const repeats=Math.ceil(this.viewport.clientWidth/baseWidth);
   for(let i=1;i<repeats;i++)this.items.forEach(item=>this.group.append(this.copy(item)));
   this.track.append(this.copy(this.group));
   const width=this.track.getBoundingClientRect().width/2,speed=Math.max(15,Number(this.dataset.speed)||45);
   this.distance=width;
   this.style.setProperty('--se-scroll-duration',(width/speed)+'s');
   const animation=this.track.getAnimations()[0];
   if(animation)animation.currentTime=((this.offset||0)%width)/speed*1000
  }
 }
 reveal(item){if(!item)return;this.style.setProperty('--se-edit-offset',-Math.max(0,item.offsetLeft-this.group.offsetLeft)+'px');this.setAttribute('data-editing','')}
 sync(){this.toggleAttribute('data-paused',this.paused||this.hover||this.focused||this.motion.matches||document.hidden)}
 disconnectedCallback(){cancelAnimationFrame(this.rebuildFrame);this.observer?.disconnect();this.abort?.abort()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se-cart-drawer"]) return;
  try {
    
if(!customElements.get('se-cart-drawer'))customElements.define('se-cart-drawer',class extends HTMLElement{
 connectedCallback(){
  this.abort=new AbortController();const options={signal:this.abort.signal};this.panel=this.querySelector('dialog');this.body=this.querySelector('[data-se-cart-body]');this.status=this.querySelector('[data-se-cart-status]');this.error=this.querySelector('[data-se-cart-error]');this.busy=false;
  if(typeof this.panel.showModal!=='function')return;
  document.addEventListener('click',event=>{const link=event.target.closest('.se-header .se-cart');if(!link||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;event.preventDefault();this.open(link);if(!this.busy)this.load()},options);
  document.addEventListener('submit',event=>{const form=event.target,product=form.closest('se-product');if(!form.matches('.se-product-form')||!product||event.defaultPrevented||!product.active?.available)return;event.preventDefault();if(!this.busy)this.add(form,product)},options);
  this.addEventListener('click',event=>{if(event.target.closest('[data-se-cart-close]')){this.panel.close();return}const button=event.target.closest('[data-cart-action]');if(button&&!button.disabled&&!this.busy){const line=button.closest('[data-line-key]'),action=button.dataset.cartAction,quantity=Number(line.dataset.quantity),step=Number(line.dataset.step)||1;this.change(line.dataset.lineKey,action==='remove'?0:Math.max(Number(line.dataset.min)||1,quantity+(action==='plus'?step:-step)),action)}},options);
  this.addEventListener('submit',event=>{if(event.target.matches('.se-cart-checkout')&&this.busy)event.preventDefault()},options);
  this.panel.addEventListener('click',event=>{if(event.target!==this.panel)return;const r=this.panel.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.panel.close()},options);
  this.panel.addEventListener('close',()=>{document.documentElement.classList.remove('se-cart-open');this.trigger?.setAttribute('aria-expanded','false');if(this.trigger?.isConnected&&!this.trigger.disabled)this.trigger.focus({preventScroll:true})},options);
  window.addEventListener('pageshow',event=>{if(event.persisted&&!this.busy)this.load(false)},options);
  this.updateCount();document.querySelectorAll('.se-header .se-cart').forEach(link=>{link.setAttribute('aria-haspopup','dialog');link.setAttribute('aria-expanded','false')});
 }
 open(trigger){if(!this.panel.open){this.trigger=trigger||document.activeElement;this.panel.showModal();document.documentElement.classList.add('se-cart-open');this.trigger?.setAttribute('aria-expanded','true')}}
 setBusy(value){this.busy=value;this.panel.setAttribute('aria-busy',String(value));this.status.textContent=value?this.dataset.loading:'';this.status.hidden=true;if(value){this.error.hidden=true;this.body.querySelectorAll('button').forEach(button=>{button.dataset.seDisabled=String(button.disabled);button.disabled=true})}else this.body.querySelectorAll('button[data-se-disabled]').forEach(button=>{button.disabled=button.dataset.seDisabled==='true';delete button.dataset.seDisabled})}
 showError(message){this.error.querySelector('[data-se-cart-error-text]').textContent=message;this.error.hidden=false}
 async request(url,options={},json=true){const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),20000);this.requestAbort=controller;try{const response=await fetch(url,{...options,credentials:'same-origin',cache:'no-store',signal:controller.signal});const data=json?await response.json():await response.text();if(!response.ok||(json&&data.status>=400)){const error=new Error(typeof data.description==='string'?data.description:typeof data.message==='string'?data.message:this.dataset.error);error.confirmed=true;throw error}return data}finally{clearTimeout(timer);if(this.requestAbort===controller)this.requestAbort=null}}
 sectionURL(){const url=new URL(this.dataset.cartUrl,location.origin);url.searchParams.set('section_id',this.dataset.sectionId);return url.href}
 render(html){if(typeof html!=='string')throw new Error(this.dataset.error);const doc=new DOMParser().parseFromString(html,'text/html'),fresh=doc.querySelector('[data-se-cart-body]');if(!fresh)throw new Error(this.dataset.error);this.body.replaceChildren(...[...fresh.childNodes]);this.body.dataset.count=fresh.dataset.count;this.body.dataset.cartLabel=fresh.dataset.cartLabel;this.updateCount()}
 updateCount(){const count=this.body.dataset.count||'0';this.querySelector('[data-se-cart-count]').textContent=count;document.querySelectorAll('.se-header .se-cart').forEach(link=>{const number=link.querySelector(':scope > span');if(number)number.textContent=count;if(this.body.dataset.cartLabel)link.setAttribute('aria-label',this.body.dataset.cartLabel)})}
 async refresh(){this.render(await this.request(this.sectionURL(),{},false))}
 async load(showError=true){this.setBusy(true);try{await this.refresh()}catch(error){if(showError)this.showError(this.dataset.error)}finally{this.setBusy(false)}}
 async add(form,product){
  const data=new FormData(form);data.set('sections',this.dataset.sectionId);data.set('sections_url',new URL(this.dataset.cartUrl,location.origin).pathname);const trigger=form.querySelector('[name="add"]');this.open(trigger);this.setBusy(true);const disabled=[...form.querySelectorAll('input,select,button')].map(el=>[el,el.disabled]);disabled.forEach(([el])=>el.disabled=true);let added=false;
  try{const result=await this.request(this.dataset.addUrl,{method:'POST',headers:{Accept:'application/json'},body:data});added=true;const html=result.sections?.[this.dataset.sectionId];if(html)this.render(html);else await this.refresh();this.body.querySelector('.se-cart-items')?.scrollTo(0,0)}catch(error){try{await this.refresh()}catch{}this.showError(added?this.dataset.addedError:error.confirmed?error.message:this.dataset.error)}finally{disabled.forEach(([el,wasDisabled])=>el.disabled=wasDisabled);if(product.isConnected)product.update(false);this.setBusy(false);if(!this.panel.open&&trigger?.isConnected)trigger.focus({preventScroll:true})}
 }
 async change(key,quantity,action){
  this.setBusy(true);try{const result=await this.request(this.dataset.changeUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity,sections:[this.dataset.sectionId],sections_url:new URL(this.dataset.cartUrl,location.origin).pathname})});const html=result.sections?.[this.dataset.sectionId];if(html)this.render(html);else await this.refresh()}catch(error){try{await this.refresh()}catch{}this.showError(error.confirmed?error.message:this.dataset.error)}finally{this.setBusy(false);if(this.panel.open){const line=[...this.body.querySelectorAll('[data-line-key]')].find(el=>el.dataset.lineKey===key),button=line?.querySelector(`[data-cart-action="${action}"]`);(button&&!button.disabled?button:this.querySelector('[data-se-cart-close]')).focus({preventScroll:true})}}
 }
 disconnectedCallback(){this.abort?.abort();this.requestAbort?.abort();if(this.panel?.open)this.panel.close();document.documentElement.classList.remove('se-cart-open')}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se-collection-media-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.se-collection-grid');

    sections.forEach((section) => {
      if (section.dataset.seCollectionReady === 'true') return;
      section.dataset.seCollectionReady = 'true';

      const videos = section.querySelectorAll('video');
      const behavior = section.dataset.videoBehavior;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const mobileMedia = window.matchMedia('(max-width: 749px)');
      const imageMedia = section.querySelectorAll('.se-collection-card__media--has-hover-image');
      const imageTimers = new WeakMap();
      let imageObserver;

      const clearImageTimer = (card) => {
        const timer = imageTimers.get(card);
        if (timer === undefined) return;

        window.clearTimeout(timer);
        imageTimers.delete(card);
      };

      const resetScrollImages = () => {
        imageMedia.forEach((media) => {
          const card = media.closest('.se-collection-card');
          if (!card) return;

          clearImageTimer(card);
          card.classList.remove('is-scroll-secondary');
        });
      };

      const setupScrollImages = () => {
        if (imageObserver) imageObserver.disconnect();
        resetScrollImages();

        if (!mobileMedia.matches || imageMedia.length === 0) return;

        imageObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const card = entry.target.closest('.se-collection-card');
            if (!card) return;

            if (entry.isIntersecting && entry.intersectionRatio >= 0.9) {
              if (card.classList.contains('is-scroll-secondary') || imageTimers.has(card)) return;

              const timer = window.setTimeout(() => {
                imageTimers.delete(card);
                if (!mobileMedia.matches) return;
                card.classList.add('is-scroll-secondary');
              }, 300);

              imageTimers.set(card, timer);
              return;
            }

            clearImageTimer(card);

            if (!entry.isIntersecting) {
              card.classList.remove('is-scroll-secondary');
            }
          });
        }, { threshold: [0, 0.9] });

        imageMedia.forEach((media) => imageObserver.observe(media));
      };

      setupScrollImages();

      if (typeof mobileMedia.addEventListener === 'function') {
        mobileMedia.addEventListener('change', setupScrollImages);
      } else if (typeof mobileMedia.addListener === 'function') {
        mobileMedia.addListener(setupScrollImages);
      }

      videos.forEach((video) => {
        video.muted = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');

        if (behavior === 'hover') {
          const card = video.closest('.se-collection-card__link');
          if (!card) return;

          const play = () => video.play().catch(() => {});
          const pause = () => video.pause();

          card.addEventListener('pointerenter', play);
          card.addEventListener('pointerleave', pause);
          card.addEventListener('focusin', play);
          card.addEventListener('focusout', pause);
          return;
        }

        if (behavior === 'autoplay' && !reduceMotion) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.play().catch(() => {});
              } else {
                entry.target.pause();
              }
            });
          }, { threshold: 0.25 });

          observer.observe(video);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se-editorial-collection"] && !Shopify.designMode) return;
  try {
    
  if (!window.seEditorialCollectionSortReady) {
    window.seEditorialCollectionSortReady = true;
    document.addEventListener('pointerdown', (event) => {
      document.querySelectorAll('[data-collection-sort-dropdown][open]').forEach((dropdown) => {
        if (!dropdown.contains(event.target)) dropdown.open = false;
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-collection-sort-dropdown][open]').forEach((dropdown) => {
        dropdown.open = false;
        dropdown.querySelector('summary')?.focus();
      });
    });
  }

  if (!window.seEditorialCollectionSwatchesReadyV3) {
    window.seEditorialCollectionSwatchesReadyV3 = true;

    const previewSwatch = (swatch) => {
      const previewSrc = swatch.dataset.previewSrc;
      const card = swatch.closest('.se-editorial-product-card');
      const image = card?.querySelector('[data-se-card-primary]');
      if (!previewSrc || !card || !image) return;

      if (!Object.prototype.hasOwnProperty.call(image.dataset, 'seOriginalSrc')) {
        image.dataset.seOriginalSrc = image.getAttribute('src') || '';
        image.dataset.seOriginalSrcset = image.getAttribute('srcset') || '';
        image.dataset.seOriginalSizes = image.getAttribute('sizes') || '';
        image.dataset.seOriginalAlt = image.getAttribute('alt') || '';
      }

      image.setAttribute('src', previewSrc);
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.setAttribute('alt', swatch.dataset.previewAlt || image.dataset.seOriginalAlt);
      const back = card.querySelector('.se-editorial-product-card__image--secondary');
      if (back && swatch.dataset.previewBackSrc) {
        if (!Object.prototype.hasOwnProperty.call(back.dataset, 'seOriginalSrc')) {
          back.dataset.seOriginalSrc = back.getAttribute('src') || '';
          back.dataset.seOriginalSrcset = back.getAttribute('srcset') || '';
          back.dataset.seOriginalSizes = back.getAttribute('sizes') || '';
          back.dataset.seOriginalAlt = back.getAttribute('alt') || '';
        }
        back.setAttribute('src', swatch.dataset.previewBackSrc);
        back.removeAttribute('srcset');
        back.removeAttribute('sizes');
        back.setAttribute('alt', swatch.dataset.previewBackAlt || '');
      }
      card.classList.add('is-swatch-previewing');
    };

    const restoreCard = (card) => {
      const image = card?.querySelector('[data-se-card-primary]');
      if (!card || !image || !Object.prototype.hasOwnProperty.call(image.dataset, 'seOriginalSrc')) return;

      image.setAttribute('src', image.dataset.seOriginalSrc);
      if (image.dataset.seOriginalSrcset) image.setAttribute('srcset', image.dataset.seOriginalSrcset);
      else image.removeAttribute('srcset');
      if (image.dataset.seOriginalSizes) image.setAttribute('sizes', image.dataset.seOriginalSizes);
      else image.removeAttribute('sizes');
      image.setAttribute('alt', image.dataset.seOriginalAlt);
      const back = card.querySelector('.se-editorial-product-card__image--secondary');
      if (back?.dataset.seOriginalSrc) {
        back.setAttribute('src', back.dataset.seOriginalSrc);
        if (back.dataset.seOriginalSrcset) back.setAttribute('srcset', back.dataset.seOriginalSrcset);
        else back.removeAttribute('srcset');
        if (back.dataset.seOriginalSizes) back.setAttribute('sizes', back.dataset.seOriginalSizes);
        else back.removeAttribute('sizes');
        back.setAttribute('alt', back.dataset.seOriginalAlt || '');
      }
      card.classList.remove('is-swatch-previewing');
    };

    document.addEventListener('click', (event) => {
      const swatch = event.target.closest('[data-se-card-swatch]');
      if (!swatch) return;
      event.preventDefault();
      const card = swatch.closest('.se-editorial-product-card');
      previewSwatch(swatch);
      card.querySelectorAll('[data-se-card-swatch]').forEach(item => {
        const selected = item === swatch;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
      card.querySelectorAll('[data-se-card-primary], .se-editorial-product-card__image--secondary').forEach(image => {
        image.dataset.seOriginalSrc = image.getAttribute('src') || '';
        image.dataset.seOriginalSrcset = image.getAttribute('srcset') || '';
        image.dataset.seOriginalSizes = image.getAttribute('sizes') || '';
        image.dataset.seOriginalAlt = image.getAttribute('alt') || '';
      });
      if (swatch.dataset.variantUrl) card.querySelectorAll('.se-editorial-product-card__media, h2 a').forEach(link => link.setAttribute('href', swatch.dataset.variantUrl));
    });

    document.addEventListener('pointerover', (event) => {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      const swatch = event.target.closest('[data-se-card-swatch]');
      if (!swatch || swatch.contains(event.relatedTarget)) return;
      previewSwatch(swatch);
    });

    document.addEventListener('pointerout', (event) => {
      const swatch = event.target.closest('[data-se-card-swatch]');
      if (!swatch) return;
      const group = swatch.closest('.se-editorial-product-card__swatches');
      if (group?.contains(event.relatedTarget)) return;
      restoreCard(swatch.closest('.se-editorial-product-card'));
    });

    document.addEventListener('focusin', (event) => {
      const swatch = event.target.closest('[data-se-card-swatch]');
      if (swatch) previewSwatch(swatch);
    });

    document.addEventListener('focusout', (event) => {
      const swatch = event.target.closest('[data-se-card-swatch]');
      if (!swatch) return;
      const group = swatch.closest('.se-editorial-product-card__swatches');
      if (group?.contains(event.relatedTarget)) return;
      restoreCard(swatch.closest('.se-editorial-product-card'));
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se-editorial-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('se-editorial-header')) {
    customElements.define('se-editorial-header', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.drawer = this.querySelector('[data-cart-drawer]');
        this.busy = false;
        const options = { signal: this.abortController.signal };

        this.querySelectorAll('[data-country-select]').forEach((select) => {
          select.addEventListener('change', () => select.form.submit(), options);
        });

        this.querySelectorAll('[data-cart-drawer-open]').forEach((opener) => {
          opener.addEventListener('click', (event) => {
            event.preventDefault();
            const storefrontDrawer = document.querySelector('se-cart-drawer');
            if (storefrontDrawer && typeof storefrontDrawer.open === 'function') {
              storefrontDrawer.open(opener);
              if (!storefrontDrawer.busy && typeof storefrontDrawer.load === 'function') storefrontDrawer.load();
              return;
            }
            this.openDrawer(opener);
          }, options);
        });

        document.addEventListener('submit', (event) => {
          const form = event.target;
          if (!(form instanceof HTMLFormElement) || !form.matches('.se-product-form') || event.defaultPrevented) return;

          const product = form.closest('se-product-v4, se-editorial-product-v4');
          const variantInput = Array.from(form.elements).find((field) => field.name === 'id' && !field.disabled);
          const addButton = form.querySelector('[name="add"], [data-add-to-cart]');
          if (!product || !variantInput?.value || addButton?.disabled) return;

          event.preventDefault();
          this.addProduct(form, product, addButton);
        }, options);

        this.drawer?.addEventListener('click', (event) => {
          if (event.target === this.drawer) this.drawer.close();
        }, options);

        this.drawer?.addEventListener('close', () => {
          document.documentElement.classList.remove('se-editorial-cart-open');
          this.querySelectorAll('[data-cart-drawer-open]').forEach((opener) => opener.setAttribute('aria-expanded', 'false'));
          this.lastOpener?.focus({ preventScroll: true });
        }, options);

        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-cart-drawer-close]')) {
            this.drawer?.close();
            return;
          }

          const button = event.target.closest('[data-cart-quantity]');
          if (!button || !this.contains(button) || this.busy) return;
          this.changeLine(button.dataset.cartKey, Number(button.dataset.cartValue));
        }, options);

        this.querySelectorAll('.se-editorial-header__mobile-menu a').forEach((link) => {
          link.addEventListener('click', () => {
            const details = link.closest('details');
            if (details) details.open = false;
          }, options);
        });

        this.querySelectorAll('[data-cart-drawer-open]').forEach((opener) => {
          opener.setAttribute('aria-haspopup', 'dialog');
          opener.setAttribute('aria-expanded', 'false');
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      openDrawer(opener) {
        if (!this.drawer || typeof this.drawer.showModal !== 'function') return;
        this.lastOpener = opener || document.activeElement;
        if (!this.drawer.open) this.drawer.showModal();
        document.documentElement.classList.add('se-editorial-cart-open');
        this.querySelectorAll('[data-cart-drawer-open]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));
      }

      setBusy(value) {
        this.busy = value;
        const content = this.querySelector('[data-cart-drawer-content]');
        if (content) {
          if (value) content.setAttribute('aria-busy', 'true');
          else content.removeAttribute('aria-busy');
        }
      }

      showCartError(message) {
        const error = this.querySelector('[data-cart-error]');
        if (!error) return;
        error.textContent = message || 'Cart update failed.';
        error.hidden = false;
      }

      renderCart(sectionMarkup) {
        const content = this.querySelector('[data-cart-drawer-content]');
        if (!content || !sectionMarkup) throw new Error('Cart refresh failed.');

        const documentFragment = new DOMParser().parseFromString(sectionMarkup, 'text/html');
        const nextHeader = documentFragment.querySelector('se-editorial-header');
        const nextContent = nextHeader?.querySelector('[data-cart-drawer-content]');
        const nextCount = nextHeader?.querySelector('[data-cart-count]');
        const currentCount = this.querySelector('[data-cart-count]');
        if (!nextContent) throw new Error('Cart refresh failed.');

        content.innerHTML = nextContent.innerHTML;
        if (currentCount) {
          currentCount.textContent = nextCount?.textContent || '0';
          currentCount.hidden = !nextCount || nextCount.hidden;
        }
      }

      async addProduct(form, product, addButton) {
        if (this.busy) return;

        this.openDrawer(addButton);
        this.setBusy(true);
        this.querySelector('[data-cart-error]')?.setAttribute('hidden', '');

        const wasDisabled = addButton?.disabled;
        if (addButton) addButton.disabled = true;

        try {
          const root = window.Shopify?.routes?.root || '/';
          const formData = new FormData(form);
          formData.set('sections', this.dataset.sectionId);
          formData.set('sections_url', window.location.pathname);

          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData
          });
          const data = await response.json();
          if (!response.ok || Number(data.status) >= 400) {
            throw new Error(data.description || data.message || 'Could not add this item to your bag.');
          }

          this.renderCart(data.sections?.[this.dataset.sectionId]);
        } catch (requestError) {
          this.showCartError(requestError.message || 'Could not add this item to your bag.');
        } finally {
          if (addButton?.isConnected) addButton.disabled = Boolean(wasDisabled);
          if (typeof product?.update === 'function' && product.isConnected) product.update(false);
          this.setBusy(false);
        }
      }

      async changeLine(key, quantity) {
        const content = this.querySelector('[data-cart-drawer-content]');
        const error = this.querySelector('[data-cart-error]');
        if (!content || !key || !Number.isFinite(quantity) || this.busy) return;

        this.setBusy(true);
        if (error) error.hidden = true;

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: key,
              quantity: Math.max(0, quantity),
              sections: [this.dataset.sectionId],
              sections_url: window.location.pathname
            })
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || 'Cart update failed.');

          this.renderCart(data.sections?.[this.dataset.sectionId]);
        } catch (requestError) {
          this.showCartError(requestError.message);
        } finally {
          this.setBusy(false);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se-editorial-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('se-editorial-home')) {
    customElements.define('se-editorial-home', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.updateViewportHeight = this.updateViewportHeight.bind(this);

        document.body.classList.add('se-editorial-home-active');
        document.body.classList.toggle('se-editorial-home-hide-header', this.dataset.hideThemeHeader === 'true');
        document.body.classList.toggle('se-editorial-home-hide-footer', this.dataset.hideThemeFooter === 'true');

        this.updateViewportHeight();
        window.addEventListener('resize', this.updateViewportHeight, { signal: this.abortController.signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        requestAnimationFrame(() => {
          const editorialHomes = document.querySelectorAll('se-editorial-home');
          document.body.classList.toggle('se-editorial-home-active', editorialHomes.length > 0);
          document.body.classList.toggle('se-editorial-home-hide-header', Boolean(document.querySelector('se-editorial-home[data-hide-theme-header="true"]')));
          document.body.classList.toggle('se-editorial-home-hide-footer', Boolean(document.querySelector('se-editorial-home[data-hide-theme-footer="true"]')));
        });
      }

      updateViewportHeight() {
        const documentTop = this.getBoundingClientRect().top + window.scrollY;
        this.style.setProperty('--se-viewport-offset', `${Math.max(0, documentTop)}px`);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se-editorial-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('se-editorial-product-v4')) {
    customElements.define('se-editorial-product-v4', class extends HTMLElement {
      connectedCallback() {
        document.body.classList.add('se-page', 'se-page--product');
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.variants = JSON.parse(this.querySelector('[data-product-variants]')?.textContent || '[]');
        this.allSlides = Array.from(this.querySelectorAll('[data-media-index]'));
        this.slides = [...this.allSlides];
        this.thumbnails = [];
        this.currentMediaIndex = Math.max(0, this.slides.findIndex((slide) => !slide.hidden));
        this.isPreviewingColor = false;
        this.committedColorKey = this.querySelector('.se-product-option--color .se-product-option__input:checked')?.dataset.colorKey || '';
        this.committedMediaId = this.slides[this.currentMediaIndex]?.dataset.mediaId || '';
        const fieldsets = Array.from(this.querySelectorAll('[data-option-index]'));
        const colorIndex = fieldsets.findIndex((fieldset) => fieldset.classList.contains('se-product-option--color'));
        this.mapVariantMediaColors(colorIndex);
        this.configureColorDependentOptions(fieldsets, colorIndex);
        this.syncColorDependentOptions(fieldsets);

        this.querySelectorAll('.se-product-option__input').forEach((input) => {
          input.addEventListener('change', (event) => this.onOptionChange(event), options);
          if (input.dataset.colorKey) {
            input.addEventListener('focus', () => { if (input.matches(':focus-visible')) this.previewColor(input); }, options);
          }
        });
        const colors = this.querySelector('.se-product-option--color');
        this.hoveredColorInput = null;
        const inputForLabel = (label) => label ? this.querySelector(`#${CSS.escape(label.htmlFor)}`) : null;
        const previewInput = (input) => {
          if (!input || input === this.hoveredColorInput) return;
          this.hoveredColorInput = input;
          this.previewColor(input);
        };
        const inputAtTarget = (target) => {
          const label = target instanceof Element ? target.closest('[data-color-preview]') : null;
          return label && colors.contains(label) ? inputForLabel(label) : null;
        };
        const leaveColor = (event) => {
          const next = inputAtTarget(event.relatedTarget);
          if (next) previewInput(next);
          else { this.hoveredColorInput = null; this.restoreCommittedColor(); }
        };
        colors?.querySelectorAll('[data-color-preview]').forEach((label) => {
          const input = inputForLabel(label);
          label.addEventListener('pointerenter', (event) => { if (event.pointerType !== 'touch') previewInput(input); }, options);
          label.addEventListener('mouseenter', () => previewInput(input), options);
          label.addEventListener('pointerleave', leaveColor, options);
          label.addEventListener('mouseleave', leaveColor, options);
        });
        colors?.addEventListener('pointermove', (event) => { if (event.pointerType !== 'touch') previewInput(inputAtTarget(event.target)); }, options);
        colors?.addEventListener('mousemove', (event) => previewInput(inputAtTarget(event.target)), options);
        colors?.addEventListener('focusout', (event) => {
          if (!this.hoveredColorInput && !colors.contains(event.relatedTarget)) this.restoreCommittedColor();
        }, options);
        this.querySelector('[data-gallery-previous]')?.addEventListener('click', () => this.showMedia(this.currentMediaIndex - 1), options);
        this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.showMedia(this.currentMediaIndex + 1), options);
        const stage = this.querySelector('[data-gallery-stage]');
        stage?.addEventListener('keydown', (event) => {
          if (event.target.closest('video, model-viewer, iframe')) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.showMedia(this.currentMediaIndex + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, options);
        stage?.addEventListener('pointerdown', (event) => { if (event.pointerType === 'touch') this.touchStart = { x: event.clientX, y: event.clientY }; }, options);
        stage?.addEventListener('pointerup', (event) => {
          if (!this.touchStart) return;
          const x = event.clientX - this.touchStart.x, y = event.clientY - this.touchStart.y;
          this.touchStart = null;
          if (Math.abs(x) > 50 && Math.abs(x) > Math.abs(y)) this.showMedia(this.currentMediaIndex + (x < 0 ? 1 : -1));
        }, options);
        stage?.addEventListener('pointercancel', () => this.touchStart = null, options);
        this.dialog = this.querySelector('[data-size-guide-dialog]');
        this.querySelectorAll('[data-size-guide-open]').forEach((button) => button.addEventListener('click', () => this.dialog?.showModal(), options));
        this.querySelector('[data-size-guide-close]')?.addEventListener('click', () => this.dialog?.close(), options);
        this.dialog?.addEventListener('click', (event) => { if (event.target === this.dialog) this.dialog.close(); }, options);
        this.moveEmbeddedSizeGuide();
        this.querySelectorAll('[data-product-description] p').forEach(paragraph => {
          if (!paragraph.textContent.trim() && !paragraph.querySelector('img, video, iframe, table')) paragraph.hidden = true;
        });
        this.setGalleryColor(this.committedColorKey, this.committedMediaId);
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.dialog?.close();
        requestAnimationFrame(() => {
          if (!document.querySelector('se-editorial-product-v4')) document.body.classList.remove('se-page', 'se-page--product');
        });
      }

      onOptionChange(event) {
        const input = event.target;
        const fieldset = input.closest('[data-option-index]');
        fieldset?.querySelector('[data-selected-option]')?.replaceChildren(input.dataset.optionLabel || input.value);

        if (input.dataset.colorKey) {
          this.committedColorKey = input.dataset.colorKey;
          this.isPreviewingColor = false;
          this.setGalleryColor(this.committedColorKey, input.dataset.previewMediaId);
          this.committedMediaId = this.slides[this.currentMediaIndex]?.dataset.mediaId || '';
        }

        const nextProductUrl = input.dataset.productUrl;
        if (nextProductUrl) {
          const currentPath = new URL(this.dataset.productUrl, window.location.origin).pathname;
          const nextUrl = new URL(nextProductUrl, window.location.origin);
          if (nextUrl.pathname !== currentPath) {
            const optionValueIds = this.selectedInputs().map((selected) => selected.dataset.optionValueId).filter(Boolean);
            if (optionValueIds.length) nextUrl.searchParams.set('option_values', optionValueIds.join(','));
            window.location.assign(nextUrl.toString());
            return;
          }
        }

        this.updateVariant();
      }

      previewColor(input) {
        if (!input?.dataset.colorKey) return;
        if (input.checked) { this.restoreCommittedColor(); return; }
        this.isPreviewingColor = true;
        this.setGalleryColor(input.dataset.colorKey, input.dataset.previewMediaId);
      }

      restoreCommittedColor() {
        if (!this.isPreviewingColor) return;
        this.isPreviewingColor = false;
        this.setGalleryColor(this.committedColorKey, this.committedMediaId);
      }

      colorKey(value) {
        const normalize = value => String(value || '').normalize('NFKC').trim().toLowerCase().replace(/grey/g, 'gray').replace(/[\s_-]+/g, '');
        const key = normalize(value);
        const input = [...this.querySelectorAll('.se-product-option--color input')].find(input => normalize(input.value) === key);
        return input?.dataset.colorKey?.trim() || key;
      }

      mapVariantMediaColors(colorIndex) {
        // Imported listings can omit alt text. Their featured variant images mark
        // the start of each color's consecutive image group.
        if (colorIndex < 0 || this.allSlides.some((slide) => slide.dataset.mediaColor)) return;
        const anchors = new Map();
        this.variants.forEach((variant) => {
          if (!variant.featuredMediaId || !variant.options[colorIndex]) return;
          const id = String(variant.featuredMediaId);
          const key = this.colorKey(variant.options[colorIndex]);
          anchors.set(id, anchors.has(id) && anchors.get(id) !== key ? '' : key);
        });
        let color = '';
        this.allSlides.forEach((slide) => {
          const id = String(slide.dataset.mediaId);
          if (anchors.has(id)) color = anchors.get(id);
          if (color) slide.dataset.mediaColor = color;
        });
      }

      configureColorDependentOptions(fieldsets, colorIndex) {
        this.colorOptionIndex = colorIndex;
        this.colorDependentOptions = new Map();
        if (colorIndex < 0) return;
        fieldsets.forEach((fieldset, index) => {
          if (index === colorIndex || fieldset.dataset.isSize === 'true') return;
          const values = new Map();
          this.variants.forEach((variant) => {
            const color = variant.options[colorIndex];
            if (!values.has(color)) values.set(color, new Set());
            values.get(color).add(variant.options[index]);
          });
          if (values.size < 2 || Array.from(values.values()).some((set) => set.size !== 1)) return;
          const mapping = new Map(Array.from(values, ([color, set]) => [color, Array.from(set)[0]]));
          if (new Set(mapping.values()).size < 2) return;
          this.colorDependentOptions.set(index, mapping);
          fieldset.hidden = true;
        });
      }

      syncColorDependentOptions(fieldsets) {
        const color = fieldsets[this.colorOptionIndex]?.querySelector('input:checked')?.value;
        this.colorDependentOptions?.forEach((mapping, index) => {
          const value = mapping.get(color);
          fieldsets[index].querySelectorAll('input').forEach((input) => { input.checked = input.value === value; });
          fieldsets[index].querySelector('[data-selected-option]')?.replaceChildren(value || '');
        });
      }

      slidesForColor(colorKey) {
        if (!colorKey) return [...this.allSlides];
        const key = this.colorKey(colorKey);
        const tagged = this.allSlides.filter((slide) => slide.dataset.mediaColor);
        return tagged.length ? tagged.filter((slide) => this.colorKey(slide.dataset.mediaColor) === key) : [...this.allSlides];
      }

      setGalleryColor(colorKey, preferredMediaId = '') {
        this.slides = this.slidesForColor(colorKey);
        const activeIds = new Set(this.slides.map((slide) => String(slide.dataset.mediaId)));

        this.allSlides.forEach((slide) => {
          slide.hidden = true;
          if (!activeIds.has(String(slide.dataset.mediaId))) slide.querySelector('video')?.pause();
        });

        this.thumbnails.forEach((button) => {
          const visible = activeIds.has(String(button.dataset.thumbnailId));
          button.hidden = !visible;
          if (!visible) {
            button.classList.remove('is-active');
            button.setAttribute('aria-pressed', 'false');
          }
        });

        let preferredIndex = this.slides.findIndex((slide) => String(slide.dataset.mediaId) === String(preferredMediaId));
        if (preferredIndex < 0) preferredIndex = this.slides.findIndex((slide) => /\bfront\b/i.test((slide.dataset.mediaCaption || '').split('|').slice(1).join('|')));
        if (preferredIndex < 0) preferredIndex = 0;
        this.showMedia(preferredIndex, false);
      }

      selectedInputs() {
        return Array.from(this.querySelectorAll('[data-option-index]')).map((fieldset) => fieldset.querySelector('.se-product-option__input:checked')).filter(Boolean);
      }

      updateVariant() {
        const fieldsets = Array.from(this.querySelectorAll('[data-option-index]'));
        this.syncColorDependentOptions(fieldsets);
        const selectedInputs = this.selectedInputs();
        const addButton = this.querySelector('[data-add-to-cart]');
        const variantInput = this.querySelector('[data-variant-id]');
        const needsSize = this.dataset.requireSize === 'true' && this.dataset.hasSizeOption === 'true';
        const hasSize = Boolean(this.querySelector('[data-is-size="true"] .se-product-option__input:checked'));

        if (selectedInputs.length !== fieldsets.length || needsSize && !hasSize) {
          variantInput.value = '';
          addButton.disabled = true;
          addButton.textContent = addButton.dataset.selectSizeLabel;
          return;
        }

        const selectedValues = fieldsets.map((fieldset) => fieldset.querySelector('.se-product-option__input:checked')?.value);
        const variant = this.variants.find((candidate) => candidate.options.every((value, index) => value === selectedValues[index]));

        if (!variant) {
          variantInput.value = '';
          addButton.disabled = true;
          addButton.textContent = addButton.dataset.soldOutLabel;
          return;
        }

        variantInput.value = variant.id;
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? addButton.dataset.addLabel : addButton.dataset.soldOutLabel;
        this.querySelector('[data-product-price]').textContent = variant.price;

        const comparePrice = this.querySelector('[data-product-compare-price]');
        comparePrice.hidden = !variant.comparePrice;
        comparePrice.textContent = variant.comparePrice || '';

        if (variant.featuredMediaId) this.showMediaById(variant.featuredMediaId);

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      showMediaById(mediaId, commit = true) {
        const index = this.slides.findIndex((slide) => String(slide.dataset.mediaId) === String(mediaId));
        if (index >= 0) this.showMedia(index, commit);
      }

      showMedia(index, commit = true) {
        if (!this.slides.length) { this.updateGalleryCount(); return; }
        this.currentMediaIndex = (index + this.slides.length) % this.slides.length;

        const activeSlide = this.slides[this.currentMediaIndex];
        this.allSlides.forEach((slide) => {
          const active = slide === activeSlide;
          slide.hidden = !active;
          if (!active) slide.querySelector('video')?.pause();
        });

        const activeId = activeSlide?.dataset.mediaId;
        this.thumbnails.forEach((button) => {
          const active = String(button.dataset.thumbnailId) === String(activeId);
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });

        if (commit && !this.isPreviewingColor) this.committedMediaId = activeId || '';

        this.updateGalleryCount();
      }

      updateGalleryCount() {
        const count = this.querySelector('[data-gallery-current]');
        const total = this.querySelector('[data-gallery-total]');
        const countWrapper = this.querySelector('[data-gallery-count]');
        const multiple = this.slides.length > 1;
        if (count) count.textContent = String(this.slides.length ? this.currentMediaIndex + 1 : 0);
        if (total) total.textContent = String(this.slides.length);
        if (countWrapper) countWrapper.hidden = !multiple;
        this.querySelectorAll('[data-gallery-control]').forEach((control) => {
          control.hidden = !multiple;
        });

        const caption = this.querySelector('[data-gallery-caption]');
        if (caption) {
          const active = this.slides[this.currentMediaIndex];
          const captionText = active?.dataset.mediaColor ? active.dataset.mediaCaption.trim() : '';
          caption.textContent = captionText;
          caption.hidden = !captionText;
        }
      }

      moveEmbeddedSizeGuide() {
        const guideContent = this.querySelector('[data-size-guide-content]');
        if (!guideContent) return;

        let table = guideContent.querySelector('table');
        if (this.dataset.hasGuidePage !== 'true') {
          const description = this.querySelector('[data-product-description]');
          table = description?.querySelector('table');
          if (table) guideContent.replaceChildren(table);
        }

        if (table) this.formatSizeGuideTable(table);
      }

      formatSizeGuideTable(sourceTable) {
        const rows = Array.from(sourceTable.rows);
        if (rows.length < 3) return;

        const sizeCells = Array.from(rows[0].cells).filter((cell) => cell.textContent.trim());
        const unitCells = Array.from(rows[1].cells).map((cell) => cell.textContent.trim()).filter(Boolean);
        const measurements = rows.slice(2).map((row) => {
          const cells = Array.from(row.cells).map((cell) => cell.textContent.trim());
          return { label: cells[0], values: cells.slice(1) };
        }).filter((row) => row.label);

        if (!sizeCells.length || unitCells.length < sizeCells.length * 2 || !measurements.length) return;

        const wrapper = document.createElement('div');
        const controls = document.createElement('div');
        const compactTable = document.createElement('table');
        controls.className = 'se-editorial-size-guide__unit-toggle';
        compactTable.className = 'se-editorial-size-guide__table';

        const inchButton = document.createElement('button');
        inchButton.type = 'button';
        inchButton.textContent = 'Inches';
        inchButton.setAttribute('aria-pressed', 'true');

        const centimeterButton = document.createElement('button');
        centimeterButton.type = 'button';
        centimeterButton.textContent = 'Centimeters';
        centimeterButton.setAttribute('aria-pressed', 'false');

        controls.append(inchButton, centimeterButton);
        wrapper.append(controls, compactTable);
        sourceTable.replaceWith(wrapper);

        const renderUnit = (unitIndex) => {
          const head = document.createElement('thead');
          const headRow = document.createElement('tr');
          const measurementHeading = document.createElement('th');
          measurementHeading.scope = 'col';
          measurementHeading.textContent = 'Measurement';
          headRow.append(measurementHeading);

          sizeCells.forEach((cell) => {
            const heading = document.createElement('th');
            heading.scope = 'col';
            heading.textContent = cell.textContent.trim();
            headRow.append(heading);
          });
          head.append(headRow);

          const body = document.createElement('tbody');
          measurements.forEach((measurement) => {
            const row = document.createElement('tr');
            const heading = document.createElement('th');
            heading.scope = 'row';
            heading.textContent = measurement.label;
            row.append(heading);

            sizeCells.forEach((cell, sizeIndex) => {
              const value = document.createElement('td');
              value.textContent = measurement.values[sizeIndex * 2 + unitIndex] || '—';
              row.append(value);
            });
            body.append(row);
          });

          compactTable.replaceChildren(head, body);
          inchButton.setAttribute('aria-pressed', String(unitIndex === 0));
          centimeterButton.setAttribute('aria-pressed', String(unitIndex === 1));
        };

        inchButton.addEventListener('click', () => renderUnit(0));
        centimeterButton.addEventListener('click', () => renderUnit(1));
        renderUnit(0);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se-email-signup"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('se-email-signup'))customElements.define('se-email-signup',class extends HTMLElement{

connectedCallback(){

 this.key='silk-echo-email-dismissed-until-v1';this.abort=new AbortController();const options={signal:this.abort.signal};this.dismissed=false;this.ready=false;this.expanded=false;

 this.closeButton=this.querySelector('[data-email-close]');this.opener=this.querySelector('[data-email-open]');this.fields=this.querySelector('[data-email-fields]');

 this.closeButton.addEventListener('click',()=>this.dismiss(),options);this.opener.addEventListener('click',()=>this.expand(true),options);this.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();this.dismiss()}},options);

 document.addEventListener('scroll',()=>this.queuePosition(),{...options,passive:true});window.addEventListener('resize',()=>this.queuePosition(),options);

 document.addEventListener('shopify:section:select',event=>{if(event.target.contains(this)){this.ready=true;this.dismissed=false;this.hidden=false}},options);

 const success=this.querySelector('[data-email-success]'),error=this.querySelector('[data-email-error]');

 if(success||error){this.ready=true;this.hidden=false;this.expand(false);if(success)this.remember();return}

 let until=0;try{until=Number(localStorage.getItem(this.key)||0)}catch{}

 if(this.dataset.editor==='true'){this.ready=true;this.hidden=false;return}

 if(until>Date.now()){this.dismissed=true;return}

 this.timer=setTimeout(()=>{this.ready=true;this.position()},Number(this.dataset.delay)*1000)

}

queuePosition(){cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.position())}

position(){

 if(!this.ready||this.dismissed)return;if(this.expanded){this.hidden=false;return}

 this.hidden=false;let overlaps=false;

 if(matchMedia('(max-width:1099px)').matches){const bounds=this.getBoundingClientRect();overlaps=[...document.querySelectorAll('.se-front-single-buy .se-btn')].some(button=>{const rect=button.getBoundingClientRect();return rect.bottom>bounds.top&&rect.top<bounds.bottom})}

 this.hidden=overlaps

}

expand(focus){this.expanded=true;this.classList.add('is-expanded');this.fields.hidden=false;this.opener.setAttribute('aria-expanded','true');if(focus)this.querySelector('input[type=email]')?.focus()}

remember(){if(this.dataset.editor==='true')return;try{localStorage.setItem(this.key,String(Date.now()+Number(this.dataset.days)*86400000))}catch{}}

dismiss(){const hadFocus=this.contains(document.activeElement);this.dismissed=true;this.hidden=true;this.remember();if(hadFocus)document.getElementById('MainContent')?.focus({preventScroll:true})}

disconnectedCallback(){clearTimeout(this.timer);cancelAnimationFrame(this.frame);this.abort?.abort()}

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se-footer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('se-footer-language-selector')) {
  customElements.define('se-footer-language-selector', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const details = this.querySelector('details');
      const summary = this.querySelector('summary');
      const options = { signal: this.abort.signal };

      document.addEventListener('click', (event) => {
        if (details?.open && !this.contains(event.target)) details.open = false;
      }, options);

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details?.open) {
          event.preventDefault();
          details.open = false;
          summary?.focus();
        }
      }, options);
    }

    disconnectedCallback() {
      this.abort?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('se-country-selector')) {
    customElements.define(
      'se-country-selector',
      class extends HTMLElement {
        connectedCallback() {
          this.abort = new AbortController();
          const options = { signal: this.abort.signal };
          const details = this.querySelector('details');
          const summary = this.querySelector('summary');

          this.addEventListener(
            'keydown',
            (event) => {
              if (event.key === 'Escape' && details.open) {
                event.preventDefault();
                details.open = false;
                summary.focus();
              }
            },
            options
          );

          document.addEventListener(
            'pointerdown',
            (event) => {
              if (!this.contains(event.target)) {
                details.open = false;
              }
            },
            options
          );
        }

        disconnectedCallback() {
          this.abort?.abort();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["se-main-product"] && !Shopify.designMode) return;
  try {
    

document.body.classList.add('se-page','se-page--product');

if(!customElements.get('se-product-v4'))customElements.define('se-product-v4',class extends HTMLElement{

 connectedCallback(){

  document.body.classList.add('se-page','se-page--product');

  this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);this.abort=new AbortController();const options={signal:this.abort.signal};

  this.form=this.querySelector('form');this.hiddenId=this.querySelector('[data-variant-id]');this.native=this.querySelector('[data-native-select]');this.button=this.querySelector('[name="add"]');this.buttonText=this.querySelector('[data-button-text]');this.status=this.querySelector('[data-status]');this.price=this.querySelector('[data-price]');this.groups=[...this.querySelectorAll('[data-option-index]')];this.gallery=this.querySelector('.se-gallery');this.slides=[...this.querySelectorAll('.se-gallery-slide')];this.counter=this.querySelector('[data-counter]');

  this.querySelector('[data-native-picker]').hidden=true;this.native.disabled=true;this.hiddenId.disabled=false;this.querySelector('[data-enhanced-picker]').hidden=false;this.querySelectorAll('.se-size input').forEach(input=>input.disabled=false);

  const initial=this.variants.find(v=>String(v.id)===this.dataset.initialVariant);if(initial)this.groups.forEach((group,i)=>group.querySelectorAll('input').forEach(input=>input.checked=input.value===initial.options[i]));

  this.form.addEventListener('change',()=>this.update(true),options);this.form.addEventListener('submit',e=>{
   if(!this.active?.available){e.preventDefault();this.update(false);return}
   const drawer=document.querySelector('se-cart-drawer');
   if(drawer&&typeof drawer.add==='function'){e.preventDefault();drawer.add(this.form,this)}
  },options);

  this.allSlides=[...this.slides];this.galleryIndex=0;this.previewingColor=false;
  this.colorGroup=this.groups.find(group=>group.hasAttribute('data-color-option'));
  if(this.colorGroup&&!this.colorGroup.querySelector('input:checked')){
   const first=this.variants.find(variant=>variant.available)||this.variants[0];
   const color=first?.options[Number(this.colorGroup.dataset.optionIndex)];
   this.colorGroup.querySelectorAll('input').forEach(input=>input.checked=input.value===color);
  }
  const colorIndex=this.groups.indexOf(this.colorGroup);
  this.mapVariantMediaColors(colorIndex);
  this.configureColorDependentOptions(this.groups,colorIndex);
  if(this.counter){
   this.querySelector('[data-prev]').addEventListener('click',()=>this.move(-1),options);
   this.querySelector('[data-next]').addEventListener('click',()=>this.move(1),options);
  }
  this.hoveredColorInput=null;
  const previewInput=input=>{if(!input||input===this.hoveredColorInput)return;this.hoveredColorInput=input;this.previewColor(input)};
  const inputAtTarget=target=>{const label=target instanceof Element?target.closest('.se-size'):null;return label&&this.colorGroup.contains(label)?label.querySelector('input'):null};
  const leaveColor=event=>{const next=inputAtTarget(event.relatedTarget);if(next)previewInput(next);else{this.hoveredColorInput=null;this.restoreColor()}};
  this.colorGroup?.querySelectorAll('.se-size').forEach(label=>{
   const input=label.querySelector('input');
   label.addEventListener('pointerenter',event=>{if(event.pointerType!=='touch')previewInput(input)},options);
   label.addEventListener('mouseenter',()=>previewInput(input),options);
   label.addEventListener('pointerleave',leaveColor,options);
   label.addEventListener('mouseleave',leaveColor,options);
   input.addEventListener('focus',()=>{if(input.matches(':focus-visible'))this.previewColor(input)},options);
  });
  this.colorGroup?.addEventListener('pointermove',event=>{if(event.pointerType!=='touch')previewInput(inputAtTarget(event.target))},options);
  this.colorGroup?.addEventListener('mousemove',event=>previewInput(inputAtTarget(event.target)),options);
  this.colorGroup?.addEventListener('focusout',event=>{if(!this.hoveredColorInput&&!this.colorGroup.contains(event.relatedTarget))this.restoreColor()},options);
  this.gallery.addEventListener('pointerdown',event=>{if(event.pointerType==='touch')this.touchStart={x:event.clientX,y:event.clientY}},options);
  this.gallery.addEventListener('pointerup',event=>{
   if(!this.touchStart)return;
   const x=event.clientX-this.touchStart.x,y=event.clientY-this.touchStart.y;this.touchStart=null;
   if(Math.abs(x)>50&&Math.abs(x)>Math.abs(y))this.move(x<0?1:-1);
  },options);
  this.gallery.addEventListener('pointercancel',()=>this.touchStart=null,options);

  this.opener=this.querySelector('[data-guide-open]');this.dialog=this.querySelector('.se-guide');

  this.prepareGuide();

  if(this.opener&&!this.opener.hidden&&this.dialog){

   const triggerFor=target=>{const trigger=target instanceof Element?target.closest('[data-guide-for]'):null;return trigger?.dataset.guideFor===this.dialog.id?trigger:null};

   document.addEventListener('click',e=>{const trigger=triggerFor(e.target);if(trigger){e.preventDefault();this.opener=trigger;this.openGuide(true)}},options);
   this.querySelector('[data-guide-close]').addEventListener('click',()=>this.closeGuide(true),options);
   this.dialog.addEventListener('close',()=>this.setGuideExpanded(false),options);
   this.dialog.addEventListener('click',event=>{if(event.target===this.dialog)this.closeGuide(true)},options);
  }

  this.captions=[...this.querySelectorAll('[data-gallery-caption]')];

  this.updateGalleryState();

  this.gallery.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.move(event.key==='ArrowRight'?1:-1)}},options);

  this.update(false)

 }

 activateTab(button){
  const name=button.dataset.tabButton;
  this.tabs.forEach(tab=>{const active=tab===button;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1});
  this.querySelectorAll('[data-tab-panel]').forEach(panel=>{const active=panel.dataset.tabPanel===name;panel.classList.toggle('is-active',active);panel.setAttribute('aria-hidden',String(!active));panel.toggleAttribute('inert',!active)})
 }

 onTabKeydown(event){
  if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
  event.preventDefault();
  const current=this.tabs.indexOf(event.currentTarget);
  const next=event.key==='Home'?0:event.key==='End'?this.tabs.length-1:(current+(event.key==='ArrowRight'?1:-1)+this.tabs.length)%this.tabs.length;
  this.activateTab(this.tabs[next]);this.tabs[next].focus()
 }

 prepareGuide(){

  const content=this.querySelector('[data-guide-content]'),description=this.querySelector('[data-full-product-description]');

  if(!content||!this.opener)return;

  if(this.dataset.extractGuide!=='false'&&description){

   const isMeasurementTable=table=>{

    const text=[...table.querySelectorAll('th,td')].map(cell=>cell.textContent).join(' ').toLowerCase();

    return table.hasAttribute('data-size-guide')||(/\b(length|shoulder|chest|bust|waist|hip|sleeve|inseam|width|largo|hombros?|pecho|manga)\b/.test(text)&&/\b(cm|inch|inches|pulg|pulgadas?|size|talla|xs|s|m|l|xl|xxl|2xl)\b/.test(text))

   };

   const tables=[...description.querySelectorAll('table')].filter(isMeasurementTable);

   if(tables.length){

    const usePage=content.textContent.trim()!==''||!!content.querySelector('img,table');

    tables.forEach(table=>{if(usePage)table.remove();else content.append(table)});

   }

  }

  content.querySelectorAll('table').forEach(table=>this.compactGuideTable(table));

  this.querySelectorAll('[data-tab-panel] p').forEach(paragraph=>{if(!paragraph.textContent.trim()&&!paragraph.querySelector('img,video,iframe,button,a'))paragraph.remove()});

  this.opener.hidden=!(content.textContent.trim()||content.querySelector('img,table'));

 }

 compactGuideTable(table){

  const rows=[...table.rows],grid=[],positions=[];

  rows.forEach((row,r)=>{

   grid[r]||=[];positions[r]=[];let col=0;

   [...row.cells].forEach(cell=>{

    while(grid[r][col])col++;

    const span=cell.colSpan||1,height=cell.rowSpan||1;positions[r].push({cell,col,span});

    for(let y=r;y<r+height;y++){grid[y]||=[];for(let x=col;x<col+span;x++)grid[y][x]=cell}

    col+=span

   })

  });

  const unit=text=>{text=text.trim().toLowerCase().replace(/\./g,'');return /^(in|inch|inches|pulg|pulgada|pulgadas)$/.test(text)?'in':/^(cm|centimeter|centimeters|centimetre|centimetres|centimetro|centimetros|centímetro|centímetros)$/.test(text)?'cm':null};

  const unitRow=rows.findIndex(row=>[...row.cells].some(c=>unit(c.textContent)==='in')&&[...row.cells].some(c=>unit(c.textContent)==='cm'));

  if(unitRow<1||unitRow>=rows.length-1)return;

  const sizes=[];

  for(let col=1;col<grid[unitRow].length;col+=2){

   const first=unit(grid[unitRow][col]?.textContent||''),second=unit(grid[unitRow][col+1]?.textContent||'');

   const header=grid[unitRow-1][col];

   if(!first||!second||first===second||!header||header!==grid[unitRow-1][col+1])return;

   sizes.push({label:header.textContent.trim(),in:first==='in'?col:col+1,cm:first==='cm'?col:col+1})

  }

  if(!sizes.length)return;

  const measurements=grid.slice(unitRow+1,rows.length).map(row=>({label:row[0]?.textContent.trim(),values:sizes.map(size=>({in:row[size.in]?.textContent.trim(),cm:row[size.cm]?.textContent.trim()}))}));

  if(measurements.some(row=>!row.label||row.values.some(v=>v.in===undefined||v.cm===undefined)))return;

  const compact=document.createElement('table');compact.className='se-compact-chart';

  const caption=compact.createCaption();caption.className='se-visually-hidden';

  const heading=this.dialog.querySelector('h2').textContent.trim();

  const header=compact.createTHead().insertRow(),unitHead=document.createElement('th');unitHead.scope='col';header.append(unitHead);

  sizes.forEach(size=>{const th=document.createElement('th');th.scope='col';th.textContent=size.label;header.append(th)});

  const body=compact.createTBody(),cells=[];

  measurements.forEach(row=>{const tr=body.insertRow(),label=document.createElement('th');label.scope='row';label.textContent=row.label;tr.append(label);cells.push(row.values.map(value=>({cell:tr.insertCell(),value})))});

  const controls=document.createElement('div');controls.className='se-guide-units';controls.setAttribute('role','group');controls.setAttribute('aria-label',heading+' (in / cm)');

  const buttons=['in','cm'].map(unit=>{const button=document.createElement('button');button.type='button';button.textContent=unit.toUpperCase();button.dataset.guideUnit=unit;controls.append(button);return button});

  const select=unit=>{unitHead.textContent=unit.toUpperCase();caption.textContent=heading+' ('+unit+')';cells.flat().forEach(({cell,value})=>cell.textContent=value[unit]);buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.guideUnit===unit)))};

  buttons.forEach(button=>button.addEventListener('click',()=>select(button.dataset.guideUnit),{signal:this.abort.signal}));

  table.replaceWith(controls,compact);select('in')

 }

 setGuideExpanded(expanded){document.querySelectorAll('[data-guide-for]').forEach(trigger=>{if(trigger.dataset.guideFor===this.dialog.id)trigger.setAttribute('aria-expanded',String(expanded))})}

 openGuide(){if(!this.dialog.open)this.dialog.showModal();this.setGuideExpanded(true)}

 closeGuide(restore){clearTimeout(this.guideTimer);this.returningFocus=true;this.dialog.close();this.setGuideExpanded(false);this.guidePinned=false;if(restore)this.opener.focus();this.returningFocus=false}

 colorKey(value){const normalize=v=>String(v||'').normalize('NFKC').trim().toLowerCase().replace(/grey/g,'gray').replace(/[\s_-]+/g,'');const key=normalize(value);const input=[...(this.colorGroup?.querySelectorAll('input')||[])].find(input=>normalize(input.value)===key);return input?.dataset.colorKey?.trim()||key}

 mapVariantMediaColors(colorIndex){
  if(colorIndex<0||this.allSlides.some(slide=>(slide.dataset.caption||'').includes('|')))return;
  const anchors=new Map();
  this.variants.forEach(variant=>{
   if(!variant.imageId||!variant.options[colorIndex])return;
   const id=String(variant.imageId),key=this.colorKey(variant.options[colorIndex]);
   anchors.set(id,anchors.has(id)&&anchors.get(id)!==key?'':key);
  });
  let color='';
  this.allSlides.forEach(slide=>{const id=String(slide.dataset.imageId);if(anchors.has(id))color=anchors.get(id);if(color)slide.dataset.mediaColor=color});
 }

 configureColorDependentOptions(fieldsets,colorIndex){
  this.colorOptionIndex=colorIndex;this.colorDependentOptions=new Map();
  if(colorIndex<0)return;
  fieldsets.forEach((fieldset,index)=>{
   if(index===colorIndex||fieldset.dataset.isSize==='true')return;
   const values=new Map();
   this.variants.forEach(variant=>{const color=variant.options[colorIndex];if(!values.has(color))values.set(color,new Set());values.get(color).add(variant.options[index])});
   if(values.size<2||[...values.values()].some(set=>set.size!==1))return;
   const mapping=new Map([...values].map(([color,set])=>[color,[...set][0]]));
   if(new Set(mapping.values()).size<2)return;
   this.colorDependentOptions.set(index,mapping);fieldset.hidden=true;
  });
 }

 syncColorDependentOptions(fieldsets){
  const color=fieldsets[this.colorOptionIndex]?.querySelector('input:checked')?.value;
  this.colorDependentOptions?.forEach((mapping,index)=>{const value=mapping.get(color);fieldsets[index].querySelectorAll('input').forEach(input=>input.checked=input.value===value)});
 }

 setGalleryColor(value,preferredImageId=''){
  const key=this.colorKey(value);
  const tagged=this.allSlides.filter(slide=>(slide.dataset.caption||'').includes('|')||slide.dataset.mediaColor);
  this.slides=key&&tagged.length?tagged.filter(slide=>this.colorKey((slide.dataset.caption||'').includes('|')?slide.dataset.caption.split('|')[0]:slide.dataset.mediaColor)===key):[...this.allSlides];
  this.allSlides.forEach(slide=>slide.hidden=true);

  const preferred=this.slides.findIndex(slide=>String(slide.dataset.imageId)===String(preferredImageId));
  const front=this.slides.findIndex(slide=>/\bfront\b/i.test((slide.dataset.caption||'').split('|').slice(1).join('|')));
  this.go(preferred>=0?preferred:front>=0?front:0);
 }

 previewColor(input){if(!input)return;if(input.checked){this.restoreColor();return}this.previewingColor=true;this.setGalleryColor(input.value)}

 restoreColor(){if(!this.previewingColor)return;this.previewingColor=false;this.setGalleryColor(this.colorGroup?.querySelector('input:checked')?.value,this.committedImageId)}

 updateGalleryState(){
  const slide=this.slides[this.galleryIndex];
  if(this.counter)this.counter.textContent=`${this.slides.length?this.galleryIndex+1:0} / ${this.slides.length}`;
  const controls=this.querySelector('.se-gallery-controls');if(controls)controls.hidden=this.slides.length<2;
  const caption=slide?.dataset.caption?.includes('|')?slide.dataset.caption.trim():'';
  this.captions?.forEach(el=>{el.textContent=caption;el.hidden=!caption});
 }

 visibleIndex(){return this.galleryIndex||0}

 go(index){
  if(!this.slides.length){this.galleryIndex=0;this.updateGalleryState();return}
  this.galleryIndex=(index+this.slides.length)%this.slides.length;
  const active=this.slides[this.galleryIndex];
  this.allSlides.forEach(slide=>slide.hidden=slide!==active);
  if(!this.previewingColor)this.committedImageId=active.dataset.imageId;
  this.updateGalleryState();
 }

 move(delta){this.go(this.visibleIndex()+delta)}

 update(change){

  this.syncColorDependentOptions(this.groups);

  const values=this.groups.map(group=>group.querySelector('input:checked')?.value);const complete=values.every(Boolean);const variant=complete?this.variants.find(v=>this.groups.length===0||v.options.every((option,i)=>option===values[i])):null;

  this.active=variant;this.hiddenId.value=variant?String(variant.id):'';this.button.disabled=!variant?.available;

  let label=!complete?this.dataset.choose:!variant?this.dataset.unavailable:!variant.available?this.dataset.sold:this.dataset.add;this.buttonText.textContent=variant?.available?`${label} — ${variant.price}`:label;this.status.textContent=change?this.buttonText.textContent:'';

  this.previewingColor=false;
  this.setGalleryColor(this.colorGroup?.querySelector('input:checked')?.value,variant?.imageId);
  if(variant){this.price.textContent=variant.price;this.native.value=String(variant.id)}

  if(change){const url=new URL(location.href);if(variant)url.searchParams.set('variant',variant.id);else url.searchParams.delete('variant');history.replaceState({},'',url)}

 }

 disconnectedCallback(){clearTimeout(this.guideTimer);this.abort?.abort();cancelAnimationFrame(this.frame);if(this.dialog?.open)this.dialog.close();requestAnimationFrame(()=>{if(!document.querySelector('se-product-v4'))document.body.classList.remove('se-page','se-page--product')})}

});


  } catch(e) { console.error(e); }
})();
})();
